export default
  [
    {
      path: '',
      redirect: 'orderManagement'
    },
    {
      path: 'orderManagement',
      name: 'orderCenter/orderManagement',
      component: () => import('@/page/orderCenter/orderManagement'),
      meta: { openKeyName: '订单中心', selectKeyUrl: 'orderManagement' }
    },
    {
      path: 'orderManagementDetail/:id',
      name: 'orderManagementDetail',
      component: () => import('@/page/orderCenter/orderManagementDetail'),
      props: true,
      meta: { openKeyName: '订单中心', selectKeyUrl: 'orderManagement' }
    },
    {
      path: 'orderCreate',
      name: 'orderCenter/orderCreate',
      component: () => import('@/page/orderCenter/orderCreate'),
      meta: { openKeyName: '订单中心', selectKeyUrl: 'orderManagement' }
    }
  ]



// WEBPACK FOOTER //
// ./src/router/orderCenter/index.js